import { mapStyles } from "../styles";

export interface MapConfig {
  style: string | maplibregl.StyleSpecification;
  center: [number, number];
  zoom: number;
  pitch?: number;
  bearing?: number;
  maxZoom?: number;
  minZoom?: number;
  antialias?: boolean;
  maxPitch: number;
  preserveDrawingBuffer: boolean;
}

export const defaultMapConfig: MapConfig = {
  style: "https://demotiles.maplibre.org/style.json",
  center: [-0.7932101487528707, 50.868488421947156], // Lavant, UK
  zoom: 8,
  pitch: 0,
  bearing: 0,
  antialias: true,
  maxZoom: 20,
  minZoom: 2,
  maxPitch: 85,
  preserveDrawingBuffer: false,
};

export const darkMapConfig: MapConfig = {
  ...defaultMapConfig,
  style: mapStyles.dark,
};
